export default {
  'name': {
    type: 'text',
    rules: [{ required: true }, { max: 80 }]
  },
  'street': {
    type: 'text',
    rules: [{ max: 250 }]
  },
  'zip': {
    type: 'number',
    rules: [{ type: 'number', max: 12 }]
  },
  'city': {
    type: 'text',
    rules: [{ max: 80 }]
  },
  'taxno': {
    type: 'text',
    rules: [{ max: 20 }]
  },
  'regno': {
    type: 'text',
    rules: [{ max: 80 }]
  },
  'contact_name': {
    type: 'text',
    rules: [{ max: 80 }]
  },
  'contact_phone': {
    type: 'text',
    rules: [{ max: 16 }]
  },
  'contact_email': {
    type: 'email',
    rules: [{ type: 'email' }, { max: 254 }]
  }
}



// WEBPACK FOOTER //
// ./src/components/owner/ownerFields.js